import React, { useEffect, useState } from 'react';
import { motion, useScroll, useMotionValueEvent } from 'framer-motion';
import { Button } from '../ui/Button';
export function StickyHeader() {
  const {
    scrollY
  } = useScroll();
  const [hidden, setHidden] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useMotionValueEvent(scrollY, 'change', latest => {
    const previous = scrollY.getPrevious() ?? 0;
    if (latest > previous && latest > 150) {
      setHidden(true);
    } else {
      setHidden(false);
    }
    setIsScrolled(latest > 50);
  });
  return <motion.header variants={{
    visible: {
      y: 0
    },
    hidden: {
      y: '-100%'
    }
  }} animate={hidden ? 'hidden' : 'visible'} transition={{
    duration: 0.35,
    ease: 'easeInOut'
  }} className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${isScrolled ? 'bg-[#0a0e1a]/90 backdrop-blur-md border-b border-white/10 shadow-lg' : 'bg-transparent'}`} data-id="element-254">
      <div className="container mx-auto px-4 py-3" data-id="element-255">
        <div className="flex items-center justify-between" data-id="element-256">
          <div className="font-display font-bold text-xl tracking-tight text-white flex items-center gap-2" data-id="element-257">
            <span aria-hidden="true" data-id="element-258">😴</span>
            <span className="hidden sm:inline" data-id="element-259">CLOSE THE GAP™</span>
          </div>

          <div className="flex items-center gap-4" data-id="element-260">
            <div className="hidden md:flex items-center gap-3 text-xs text-slate-400 mr-4" data-id="element-261">
              <span className="flex items-center gap-1" data-id="element-262">
                <span aria-hidden="true" data-id="element-263">🛡️</span> Garantía 7 días
              </span>
              <span className="flex items-center gap-1" data-id="element-264">
                <span aria-hidden="true" data-id="element-265">🔒</span> Pago seguro
              </span>
            </div>
            <Button size="sm" href="#pricing" className="shadow-none" data-id="element-266">
              QUIERO MI MEGAPACK
            </Button>
          </div>
        </div>
      </div>
    </motion.header>;
}